const ApiUtil = {
  buildQueryStringForPaged(
    page,
    resultsPerPage,
    sortBy,
    isDescending,
    search,
    filters,
  ) {
    const queryStrings = [];

    // Page
    queryStrings.push(`page=${encodeURIComponent(page)}`);

    // Limit
    queryStrings.push(`limit=${encodeURIComponent(resultsPerPage)}`);

    // Ordering
    if (sortBy) {
      queryStrings.push(`orders[${sortBy}]=${isDescending ? 'DESC' : 'ASC'}`);
    }

    // Search
    if (search) {
      queryStrings.push(`search=${encodeURIComponent(search)}`);
    }

    // Filters
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key].value)) {
        const qs = ApiUtil.listToQueryString(filters[key].field, filters[key].value);

        if (qs !== null) {
          queryStrings.push(qs);
        }
      } else if (filters[key].value) {
        queryStrings.push(`${encodeURIComponent(filters[key].field)}=${encodeURIComponent(filters[key].value)}`);
      }
    });

    return queryStrings.join('&');
  },
  buildArrayToQueryString(fieldName, listValue) {
    if (typeof listValue !== 'object' || listValue.length === 0) {
      return null;
    }

    return Object.keys(listValue).map(key => `${fieldName}[]=${listValue[key]}`).join('&');
  },
  buildFilter(filters) {
    const queryStrings = [];

    // Filters
    Object.keys(filters).forEach((key) => {
      if (Array.isArray(filters[key].value)) {
        const qs = ApiUtil.listToQueryString(filters[key].field, filters[key].value);

        if (qs !== null) {
          queryStrings.push(qs);
        }
      } else if (filters[key].value) {
        queryStrings.push(`${encodeURIComponent(filters[key].field)}=${encodeURIComponent(filters[key].value)}`);
      }
    });

    return queryStrings.join('&');
  },
  listToQueryString(fieldName, listValue) {
    if (typeof listValue !== 'object' || listValue.length === 0) {
      return null;
    }

    return Object.keys(listValue).map(key => `${fieldName}[]=${listValue[key]}`).join('&');
  },
  objectToFormData(object) {
    const formData = new FormData();
    Object.keys(object)
      .forEach((fieldName) => {
        formData.append(fieldName, object[fieldName] ? object[fieldName] : '');
      });
    return formData;
  },
  getFileNameFromHeader(headers) {
    let fileName = '';
    if (typeof (headers['content-disposition']) !== 'undefined') {
      const matches = /filename[^;=\n]*=((['"])(.*?)\2|[^;\n]*)/.exec(headers['content-disposition']);

      if (matches && matches[3]) {
        fileName = String(matches[3]);
      } else if (matches && matches[1]) {
        fileName = String(matches[1]);
      }
    }

    return fileName;
  }
};

export default ApiUtil;
